'use client';
import { type ProductDetailsData } from '@repo/ui/src/modules/UI';
import { useVipAccess } from '@hooks/customer';
import { ErrorState } from '@repo/ui/src/components/Form';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';

interface Props {
  product: ProductDetailsData;
}

const ProductDetailsDrawerVipError = ({ product }: Props) => {
  const { vip } = useVipAccess();
  const { t } = useTranslation();

  const showVipDisclaimer = vip && !product.isOrderable && !product.purchasing?.traegerExclusive;

  return (
    <ErrorState
      text={
        showVipDisclaimer
          ? t('productDetailPageContent.vipDiscountNotApplicable', undefined, {
              default:
                "This product isn't available for VIP purchase. You can still find it at full price through our trusted retail partners.",
            })
          : undefined
      }
    />
  );
};

export default ProductDetailsDrawerVipError;
